module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<table class='user-profile-data edit'>\n    <tr>\n        <td class='user-profile-data-label'>фио</td>\n        <td>\n            <div class='user-profile-data-group'>\n                <div class='user-profile-data-fio'>\n                    <control type=\"text\" html-name=\"name\" target=\"user.name\"/>\n                </div>\n            </div>\n        </td>\n    </tr>\n    <tr>\n        <td class='user-profile-data-label'>логин</td>\n        <td>\n            <control type=\"text\" html-name=\"login\" target=\"user.login\"/>\n        </td>\n    </tr>\n    <tr>\n        <td class='user-profile-data-label'>пароль</td>\n        <td>\n            <control type=\"password\" html-name=\"password\" target=\"user.password\"/>\n        </td>\n    </tr>\n    <tr>\n        <td class='user-profile-data-label'>еще раз пароль</td>\n        <td>\n            <control type=\"password\" html-name=\"passwordconfirm\" target=\"user.passwordconfirm\"/>\n        </td>\n    </tr>\n</table>")
  }
  return __output.join("");

}